module.exports = __webpack_public_path__ + "img/app1.f03012e.png";